import Configs from '../configs';

const Paths = {
    HOME: Configs.PUBLIC_URL,
    HISTORY: `${Configs.PUBLIC_URL}/history`,
    NOT_FOUND: '*',
};

export default Paths;